import gql from "graphql-tag";

export const GYM_BRANCHES_QUERY = gql`
  query gymBranches($gymId: ID) {
    gymBranches(gymId: $gymId) {
      id
      title
      gym {
        id
        title
      }
    }
  }
`;
